/**
 * Which footer the Re-edit modal shows (prod fixes 2026-10-02, PLAN.md C6). Pure, so the precedence is
 * pinned by a test rather than by the order of `if`s in a render method:
 *
 *   expired > running > unchanged-success > default
 *
 * - `expired`: the upload is gone (FIX-2, T3) -- Apply & Restart is replaced by "Upload it again" / "Close".
 * - `running`: the same file is already converting with these settings (FIX-8, T10) -- Apply disabled with
 *   its reason.
 * - `unchanged-success`: these are the settings already used and the output is still there (FIX-8, T10) --
 *   "Download result" primary, "Run it again anyway" tertiary. Never while a `suggestion` (FIX-3's "Make it
 *   smaller", T5) is preselected: the modal then opens on a CHANGED setting by construction.
 * - `default`: Apply & Restart + Cancel, exactly as today.
 */
export type ReeditFooterMode = 'expired' | 'running' | 'unchanged-success' | 'default';

export interface ReeditFooterInputs {
    expired?: boolean;
    running?: boolean;
    unchangedSucceeded?: boolean;
    suggestion?: unknown;
}

export function resolveReeditFooterMode(inputs: ReeditFooterInputs = {}): ReeditFooterMode {
    if (inputs.expired === true) return 'expired';
    if (inputs.running === true) return 'running';
    if (inputs.unchangedSucceeded === true && !inputs.suggestion) return 'unchanged-success';
    return 'default';
}

/** FIX-3 "Make it smaller": the one stronger option the modal opens with (T5 applies it). */
export interface ReeditSuggestion {
    optionKey: string;
    value: string;
    /** Human label for X3-B2 ("We've picked a stronger setting: {label}. You can change it."). */
    label: string;
}

/** An inline refusal at the top of the modal body (`role="alert"`, focused and scrolled into view). */
export interface ReeditAlert {
    text: string;
    actions?: { label: string; primary?: boolean; onClick: () => void }[];
}
